







import { Component, Vue, Inject, Provide } from "vue-property-decorator";
import homeHeader from "@/components/header.vue";
@Component({
  name: "App",
  components: {
    homeHeader,
  },
})
export default class extends Vue {
  public path = "";
  public created() {
    // 是否为开发环境
    if (process.env.NODE_ENV === "development") {
      //   this.$store.state.home.baseUrl = "";
      //   this.$store.state.home.baseUrl = "http://static.dhsf.xqhuyu.com/offical";
      this.$store.state.home.baseUrl =
        "https://static.dhsf.xqhuyu.com/office/android";
    } else {
      this.$store.state.home.baseUrl = "http://static.dhsf.xqhuyu.com/offical";
    }
    if (!this.isMobile()) {
    //   location.href = "https://996m2.com/"; // 线上
      // location.href = "http://10.40.3.110:8080/";
    }
  }
  public isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }
}
